import { getInitials } from 'components/Chat/helper'
import React from 'react'

export interface IAppNameInitialsProps {
  className?: string
  name: { firstName: string; lastName: string }
}

export const AppNameInitials: React.FC<IAppNameInitialsProps> = ({ className, name }) => {
  return (
    <span
      className={`rounded-full inline-flex justify-center items-center text-white font-semibold uppercase ${className}`}
    >
      {getInitials(name)}
    </span>
  )
}

AppNameInitials.defaultProps = {
  className: 'bg-tertiary h-[50px] w-[50px]',
}
